export enum ScheduledTaskStatus {
    Ready = 'Ready',
    Disabled = 'Disabled',
    Running = 'Running',
    Queued = 'Queued',
    Unknown = 'Unknown',
}
